export enum PmReportsRedemptionHistoryMessages {
  ARCHIVE_LABEL = 'Archive',
  ARCHIVE_HEADING = 'Are you sure you want to archive the point redemption(s)',
}
